module.exports = __webpack_public_path__ + "media/julio_bottom_navigation_scroll.d77d1174.mp4";